module.exports = __webpack_public_path__ + "static/ViraloTv-a0f96b3e4cd3276b57ed31a61849eb31.png";